import { gql } from '@apollo/client'

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInputDTO!) {
    login(input: $input) {
      token
      user {
        id
        name
        contactNo
        status
        roleName
      }
      branches {
        id
        name
      }
      permissions
    }
  }
`
